namespace TabAurous.Reports {
    export namespace ShortListService {
        export const baseUrl = 'Reports/ShortList';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ShortListRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Common.Vouchers>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/ShortList/List",
            GetVouchers = "Reports/ShortList/GetVouchers"
        }

        [
            'List', 
            'GetVouchers'
        ].forEach(x => {
            (<any>ShortListService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
